import { useMutation } from '@tanstack/react-query'

import { httpService } from '@/api/v1/http.service'

const useRemoveCourse = ({
  onSuccess,
  onError
}: {
  onSuccess: () => void
  onError: () => void
}) =>
  useMutation({
    mutationFn: (courseId: string) =>
      httpService.panel.panelCoursesDestroy(courseId),
    onSuccess,
    onError
  })

export default useRemoveCourse
